<template>
  <main class="detail-teacher">
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading"> <i class="arrow left"></i> {{ $t("common.back") }} </a>
          </template>
          <template v-if="statusSchoolYear" v-slot:right-element>
            <div class="d-flex buttons-wrapper buttons-teachers">
              <EditParent :parent="parent" @handleData="getDetails()" :icon="false" />
              <a @click.prevent="confirmDeleteParent()" class="btn btn-outline-primary" :disabled="loading"> <i class="icon-trash"></i> {{ $t("common.delete") }} </a>
            </div>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">{{ $t("common.loading") }}</span>
      </div>
    </div>
    <div v-if="!loading">
      <div class="general-info">
        <div class="details">
          <div class="row container-fluid">
            <div class="col-md-12">
              <h3>{{ $t("common.generalInfo") }}</h3>
            </div>
            <div v-for="(item, index) in computedData" :key="index" class="col-md-6 bloc-info">
              <span class="name_propre">
                <b>{{ item.text }} : </b>{{ item.value ? item.value : `${$t("common.nonRembler")}` }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ParentService from "../../services/parent.service";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import EditParent from "../../components/parents/EditParent";
import {mapGetters} from "vuex";
export default {
  name: "show-parent",
  components: {
    TopTemplate,
    EditParent,
  },
  data() {
    return {
      ParentId: null,
      loading: false,
      passageYears: null,
      parent: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    computedData() {
      return [
        {
          text: this.$t("parents.firstLastName"),
          value: this.parent?.last_name + " " + this.parent?.first_name,
        },
        {
          text: this.$t("parents.numTel"),
          value: this.parent?.phone ? this.formatPhone(this.parent?.phone) : null,
        },
        {
          text: this.$t("parents.email"),
          value: this.parent?.email,
        },
        {
          text: this.$t("parents.function"),
          value: this.parent?.function,
        },
        {
          text: this.$t("parents.workAt"),
          value: this.parent?.lieu_travail,
        },
        {
          text: this.$t("parents.adress"),
          value: this.parent?.addresse,
        },
        {
          text: this.$t("parents.pays"),
          value: this.parent?.pays,
        },
        {
          text: this.$t("parents.ville"),
          value: this.parent?.ville,
        },
        {
          text: this.$t("parents.code_postale"),
          value: this.parent?.code_postale,
        },
      ];
    },
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.passageYears = val.id;
        this.getDetails();
      }
    },
  },
  created() {
    this.ParentId = this.$route.params.id;
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.getDetails();
    }
  },
  methods: {
    async getDetails() {
      this.loading = true;
      try {
        const {data} = await ParentService.get(this.ParentId, {params: {school_year: this.passageYears}});
        this.parent = data.data;
      } catch (error) {
        if (error.response?.status === 404) {
          this.$router.push("/error-404");
        }
      } finally {
        this.loading = false;
      }
    },
    formatPhone(value) {
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      return phoneNumber ? phoneNumber.formatNational() : null;
    },
    async confirmDeleteParent() {
      try {
        const Swal = require("sweetalert2");
        const result = await Swal.fire({
          title: this.$t("common.confirmDeleteParentShow", {name: this.parent?.last_name + " " + this.parent?.first_name}),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        });
        if (result.isConfirmed) {
          await this.deleteParent();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteParent() {
      const Swal = require("sweetalert2");
      try {
        await ParentService.delete(this.ParentId);
        Swal.fire(this.$t("common.parentDeleted"), "", "success");
        this.$router.push({name: "parent_list"});
      } catch (error) {
        Swal.fire(this.$t("common.parentNotDeleted"), "", "success");
        console.error(error);
      }
    },
  },
};
</script>
